const endpoint = '/api/properties';
const brandendpoint = (property) => `/api/${property.id}/brand${(property.brand.id ? `/${property.brand.id}` : '')}`;

export default ['api', function(api) {
  return {
    save: property => {
      let url = property.id ? `${ endpoint }/${ property.id }` : endpoint;

      return api.upload(url, property).then(response => response.data);
    },
    saveBrand: property => {
      return api.upload(brandendpoint(property), property.brand).then(response => response.data);
    },
    delete: id => api.delete(`${ endpoint }/${ id }`),
    findAll: (page = undefined, perpage = undefined, deleted = undefined) => {
      return api.get(endpoint+(page ? '?page='+(page)+ (page > -1 ? '&perpage='+(perpage || '20') : '') : '')+(deleted ? '&deleted=true' : '')).
        then(response => response.data);
    },
    findById: id => {
      return api.get(`${ endpoint }/${ id }`)
        .then(response => response.data)
        .catch(error => {
            // Presume this has failed due to access rights
            window.location = '/403';
        });
    },
    search: (type, text, page = null) => {
      return api.get(`${endpoint}?type=${type}&text=${text}`+(page ? '&page='+page : '')).then(response => response.data);
    },
    updateDetails: (data, id, type) => {
      let dispatch = {
        'property_id' : id,
        'data': data
      };

      return api.upload(`${endpoint}/${type}/${id}`, dispatch).then(response => response.data);
    },
    import: (csv) => {
      return api.upload(`${endpoint}/import`, {file: csv}).then(response => response.data);
    }
  };
}];



// WEBPACK FOOTER //
// ./frontend/admin/app/modules/property/services/properties.service.js